import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

export const DetailsListItem = ({ title, value }: { title: string; value: ReactNode }) => (
  <Stack
    direction="row"
    sx={({ palette }) => {
      return {
        borderTop: `1px solid ${palette.border.main}`,
        flex: 0,
        py: 1.5,
      };
    }}
    data-testid="details-list-item"
  >
    <Box
      sx={{
        alignItems: 'baseline',
        flex: '0 0 100px',
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 'bold',
        }}
      >
        {title}
      </Typography>
    </Box>
    <Box sx={{ width: '100%' }}>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Typography variant="subtitle2">{value}</Typography>
      ) : (
        value
      )}
    </Box>
  </Stack>
);
